module.exports = __webpack_public_path__ + "img/yoga_demo-600x450.e6fad0ad.jpg";